import update from 'immutability-helper';
import ActionTypes from 'constants/ActionTypes';
import { FEATURE_TYPES } from 'constants/SerpFeatureTypes';

const initialState = {
    accessDenied: {
        visibility: false,
    },
    export: {
        visibility: false,
    },
    failure: {
        visibility: false,
        details: null,
        header: null,
    },
    keywordDifficultyInfo: {
        visibility: false,
    },
    loggedOut: {
        visibility: false,
    },
    needToSignIn: {
        visibility: false,
    },
    noConnection: {
        visibility: false,
    },
    serpFeaturesImpactInfo: {
        visibility: false,
    },
    pricing: {
        visibility: false,
    },
    serpFeatureInfo: {
        featureType: FEATURE_TYPES.ADV_TOP,
        subFeature: false,
        visibility: false,
    },
    topLevel: {
        announcement: {
            visibility: true,
        },
    },
    shortcuts: {
        visibility: false,
    },
};

const messagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.UI_MESSAGES_ACCESS_DENIED_CLOSE: {
            return update(state, {
                accessDenied: {
                    visibility: {
                        $set: false,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_ACCESS_DENIED_SHOW: {
            return update(state, {
                accessDenied: {
                    visibility: {
                        $set: true,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_EXPORT_CLOSE: {
            return update(state, {
                export: {
                    visibility: {
                        $set: false,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_EXPORT_SHOW: {
            return update(state, {
                export: {
                    visibility: {
                        $set: true,
                    },
                },
            });
        }
        case ActionTypes.DATA_EXPORT_RESULTS_ERROR: {
            return update(state, {
                export: {
                    visibility: {
                        $set: false,
                    },
                },
            });
        }
        case ActionTypes.DATA_EXPORT_RESULTS_FINISHED: {
            return update(state, {
                export: {
                    visibility: {
                        $set: false,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_FAILURE_SHOW: {
            return update(state, {
                failure: {
                    visibility: {
                        $set: true,
                    },
                    details: {
                        $set: action.payload.details,
                    },
                    header: {
                        $set: action.payload.header,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_FAILURE_CLOSE: {
            return update(state, {
                failure: {
                    visibility: {
                        $set: false,
                    },
                    details: {
                        $set: null,
                    },
                    header: {
                        $set: null,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_TOP_LEVEL_ANNOUNCEMENT_CLOSE: {
            return update(state, {
                topLevel: {
                    announcement: {
                        visibility: {
                            $set: false,
                        },
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_NO_CONNECTION_SHOW: {
            return update(state, {
                noConnection: {
                    visibility: {
                        $set: true,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_NO_CONNECTION_CLOSE: {
            return update(state, {
                noConnection: {
                    visibility: {
                        $set: false,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_PRICING_SHOW: {
            return update(state, {
                pricing: {
                    visibility: {
                        $set: true,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_PRICING_CLOSE: {
            return update(state, {
                pricing: {
                    visibility: {
                        $set: false,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_LOGGED_OUT_SHOW: {
            return update(state, {
                loggedOut: {
                    visibility: {
                        $set: true,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_LOGGED_OUT_CLOSE: {
            return update(state, {
                loggedOut: {
                    visibility: {
                        $set: false,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_KD_INFO_SHOW: {
            return update(state, {
                keywordDifficultyInfo: {
                    visibility: {
                        $set: true,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_KD_INFO_CLOSE: {
            return update(state, {
                keywordDifficultyInfo: {
                    visibility: {
                        $set: false,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_SERP_FEATURE_INFO_SHOW: {
            return update(state, {
                serpFeatureInfo: {
                    featureType: {
                        $set: action.payload.featureType,
                    },
                    subFeature: {
                        $set: action.payload.subFeature,
                    },
                    visibility: {
                        $set: true,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_SERP_FEATURE_INFO_CLOSE: {
            return update(state, {
                serpFeatureInfo: {
                    visibility: {
                        $set: false,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_SERP_FEATURES_IMPACT_INFO_CLOSE: {
            return update(state, {
                serpFeaturesImpactInfo: {
                    visibility: {
                        $set: false,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_SERP_FEATURES_IMPACT_INFO_SHOW: {
            return update(state, {
                serpFeaturesImpactInfo: {
                    visibility: {
                        $set: true,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_NEED_TO_SIGN_IN_CLOSE: {
            return update(state, {
                needToSignIn: {
                    visibility: {
                        $set: false,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_NEED_TO_SIGN_IN_SHOW: {
            return update(state, {
                needToSignIn: {
                    visibility: {
                        $set: true,
                    },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_SHORTCUTS_SHOW: {
            return update(state, {
                shortcuts: {
                    visibility: { $set: true },
                },
            });
        }
        case ActionTypes.UI_MESSAGES_SHORTCUTS_CLOSE: {
            return update(state, {
                shortcuts: {
                    visibility: { $set: false },
                },
            });
        }
        case ActionTypes.UI_ALL_CLOSE: {
            return update(state, {
                accessDenied: {
                    visibility: { $set: false },
                },
                export: {
                    visibility: { $set: false },
                },
                failure: {
                    visibility: { $set: false },
                    details: { $set: initialState.failure.details },
                    header: { $set: initialState.failure.header },
                },
                keywordDifficultyInfo: {
                    visibility: { $set: false },
                },
                loggedOut: {
                    visibility: { $set: false },
                },
                noConnection: {
                    visibility: { $set: false },
                },
                serpFeaturesImpactInfo: {
                    visibility: { $set: false },
                },
                pricing: {
                    visibility: { $set: false },
                },
                serpFeatureInfo: {
                    featureType: { $set: initialState.serpFeatureInfo.featureType },
                    subFeature: { $set: initialState.serpFeatureInfo.subFeature },
                    visibility: { $set: false },
                },
                shortcuts: {
                    visibility: { $set: false },
                },
            });
        }
        default: {
            return state;
        }
    }
};

export default messagesReducer;
